import React from "react";
import * as Yup from "yup";
import { Formik, Form } from "formik";
import {
    TextField,
    Button,
    Typography,
    Link,
    DialogActions,
    CircularProgress
} from "@mui/material";

const LoginSchema = Yup.object().shape({
    email: Yup.string()
        .email("Invalid email")
        .required("Email is required"),
    password: Yup.string()
        .required("Password is required")
        .min(8, "Password is too short")
        .max(50, "Password is too long")
        .matches(/[!@#$%^&*(),.?":{}|<>]/, "Password must contain at least one special character.") // Special character check
        .matches(/[A-Z]/, "Password must contain at least one uppercase letter.") // Uppercase letter check
        .matches(/[a-z]/, "Password must contain at least one lowercase letter.") // Lowercase letter check
        .matches(/\d/, "Password must contain at least one digit."), // Digit check
});


const LoginForm = ({ isLoggingIn, onRegister, onSubmit, onClose, onForgotPassword }) => (
    <Formik
        initialValues={{ email: "", password: "" }}
        validationSchema={LoginSchema}
        onSubmit={onSubmit}
    >
        {({ values, errors, touched, handleChange, handleBlur }) => (
            <Form>
                {/* Email */}
                <TextField
                    // autoFocus
                    margin="dense"
                    id="email"
                    name="email"
                    label="Email"
                    type="email"
                    fullWidth
                    value={values.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.email && Boolean(errors.email)}
                    helperText={touched.email && errors.email}
                    disabled={isLoggingIn}
                />

                {/* Password */}
                <TextField
                    margin="dense"
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    autoComplete="password"
                    fullWidth
                    value={values.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={touched.password && Boolean(errors.password)}
                    helperText={touched.password && errors.password}
                    disabled={isLoggingIn}
                />


                <Typography variant="body2" sx={{ mt: 2 }}>
                    {isLoggingIn ? (
                        <span style={{ color: "gray", cursor: "default" }}>Forgot Password?</span>
                    ) : (
                        <Link color="primary.dark" style={{ cursor: "pointer" }} onClick={onForgotPassword}>Forgot Password?</Link>
                    )}
                </Typography>

                <DialogActions>
                    <Button onClick={onRegister}
                        sx={{
                            color: "primary.dark"
                        }}
                        disabled={isLoggingIn}>Register
                    </Button>

                    <Button
                        onClick={onClose}
                        disabled={isLoggingIn}
                        sx={{
                            color: "warning.dark"
                        }}
                    >Cancel</Button>

                    <Button
                        type="submit"
                        sx={{
                            color: "primary.dark"
                        }}
                        disabled={isLoggingIn}
                        startIcon={isLoggingIn ? <CircularProgress /> : null}
                    >
                        {isLoggingIn ? "Logging in..." : "Login"}
                    </Button>
                </DialogActions>
            </Form>
        )}
    </Formik>
);

export default LoginForm;
